import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import ThemeSwitcherButton from "./components/ButtonTheme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeSwitcherButton className="fixed bottom-4 right-4 z-50" />
      <App />
    </Provider>
  </React.StrictMode>
);
